import styled from 'styled-components';
import { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-bottom: 1rem;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white4};
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > header {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.gray5};

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-bottom: unset;
    }

    & > span {
      font-weight: 600;
    }
  }

  & > div.inputs-container {
    display: flex;
    flex-direction: column;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      flex-direction: row;
    }

    & > div {
      display: flex;
      align-items: flex-end;
      flex-direction: column;

      @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
        flex-direction: row;
      }
    }
  }

  &.all-disabled {
    opacity: 0.5;
  }
`;

export const FilterInputContainer = styled.div<{ searchTextField?: boolean }>`
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;

  ${({ searchTextField }) =>
    searchTextField &&
    css`
      :first-child {
        width: 550px;
      }
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    &:first-child {
      margin-right: 1rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: 14.5rem;
    margin-right: 1rem;
    margin-bottom: unset;
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
  }

  & > .ant-select {
    width: 100%;
  }

  & > .date-range {
    margin-bottom: unset;
  }
`;
